var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnyapi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    viewBox: "0 0 44 40",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4629 10.9775L0 39.6572L23.877 0L30.4629 10.9775ZM30.5039 19.8975C32.2655 19.8976 33.8971 20.8245 34.7988 22.3379L43.0703 36.2217C43.8645 37.5548 42.9033 39.2451 41.3516 39.2451H35.3623C33.6007 39.245 31.9691 38.3181 31.0674 36.8047L20.9951 19.8975H30.5039Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnyapi);
export default __webpack_public_path__ + "static/media/anyapi.e3767bdc854ed2822cb09ffb29cd2ffd.svg";
export { ForwardRef as ReactComponent };